import { useEffect, useState } from "react"
import { useMobileDetection } from "../../../shared/hooks/useMobileDetection"
import { BiSearch } from "react-icons/bi"
import { obtenerFechaActual, obtenerLabel, obtenerLocalStorage } from "../../../shared/utils/funciones"
import { useLocation } from "react-router-dom"
import { CONST_KEY_USUARIO_AUTENTICADO, CONST_ROL_MASTER } from "../../../app/constants/constanst-valores"
import { useForm } from "react-hook-form"
import { sucursalesPorCompania } from "../../sucursales"
import { usuarioObtenerCompaniasYSucursales } from "../../usuarios"
import { listarAuditoria } from "../api/auditoria.api"
import { TablaSkeleton } from "../../../shared/ui/TablaSkeleton";
export const Auditoria = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [listaCompanias, setListaCompanias] = useState<any[]>([])
    const [listaSucursales, setListaSucursales] = useState<any[]>([])
    const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);
    const [listaAuditoria, setListaAuditoria] = useState<any[]>([])


    const rol = usuarioAutenticado?.tipo

    const location = useLocation();
    const datosParaBusquedaRapida = location?.state || null

    const isMobile = useMobileDetection()

    const { register, handleSubmit, watch, setValue } = useForm({
        defaultValues: {
            nombre: "",
            compania: "",
            sucursal: "",
            fechaInicial: obtenerFechaActual(),
            fechaFinal: obtenerFechaActual(),
            Estado: "A"
        }
    });


    const [buscar, setBuscar] = useState(false)

    const onSubmitBuscar = async (data) => {

        setIsLoading(true)

        const dataPOST = {
            compania: data?.compania,
            sucursal: data?.sucursal,
            nombre: data?.nombre,
            fecha_ini: data?.fechaInicial,
            fecha_fin: data?.fechaFinal,

            token: usuarioAutenticado?.token
        }
        // const { usuarios } = await usuariosBuscar(dataPOST)


        const  auditorias  = await listarAuditoria(dataPOST)
        setListaAuditoria(auditorias.resultado as any)
        setBuscar(true)
        setIsLoading(false)
        //console.log("la lsita obtenida: ", listaAuditoria)


    }
    const obtenerSucursalesPorCompania = async (idCompania) => {

        const dataPOST = {
            token: usuarioAutenticado?.token,
            Codigo: idCompania,
            Estado: "A"

        }
        const { sucursales } = await sucursalesPorCompania(dataPOST)


        const listaSucursalesFormateada = sucursales?.map(s => ({
        id: s?.CompCod,
        tipo: s?.CompNom
        }))

        setListaSucursales(listaSucursalesFormateada)


        setValue("compania", idCompania)
        setValue("sucursal", sucursales?.[0]?.CompCod)

    }
    const obtenerSucursalesPorCompaniaPorDefecto = async (idCompania) => {

        const dataPOST = {
            token: usuarioAutenticado?.token,
            Codigo: idCompania,
            Estado: "A"
        }

        const { sucursales } = await sucursalesPorCompania(dataPOST)

        const listaSucursalesFormateada = sucursales?.map(s => ({
            id: s?.CompCod,
            tipo: s?.CompNom
        }))

        setListaSucursales(listaSucursalesFormateada)

        setValue("sucursal", datosParaBusquedaRapida == null ? sucursales?.[0]?.CompCod : datosParaBusquedaRapida?.codSucursal)

    }
    const obtenerCompaniasYSucursales = async () => {

        const dataPOST = {
            token: usuarioAutenticado?.token
        }

        const { companias, sucursales } = await usuarioObtenerCompaniasYSucursales(dataPOST)

        setListaCompanias(companias)

        setListaSucursales(sucursales)

        setValue("compania", datosParaBusquedaRapida == null ? companias?.[0]?.id : datosParaBusquedaRapida?.codCompania)

        return {
            companias,
            sucursales

        }
    }
    const obtenerSedesPorSucursal = async (idCompania) => {


        setValue("sucursal", idCompania)



    }

    useEffect(() => {

        const cargarDatosIniciales = async () => {
            const { sucursales } = await obtenerCompaniasYSucursales()
            if (rol === CONST_ROL_MASTER) {
                await obtenerSucursalesPorCompaniaPorDefecto(watch("compania"));
            } else {
                setListaSucursales(sucursales)
                setValue("sucursal", sucursales?.[0]?.id as any)
            }

            // await obtenerUsuarios()
        };

        cargarDatosIniciales();

        // efecto intencional (no re-ejecutar por deps faltantes)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className="p-3">
                <div className="container-fluid" >
                    <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Auditoria</h3>
                    <div className="tw-mb-4 tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-md tw-border tw-border-gray-100">
                        <form onSubmit={handleSubmit(onSubmitBuscar)} className="row g-2">
                            <div className="col-12 col-md-2">

                                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Compañia</label>
                                <select
                                    {...register("compania", {
                                        onChange: async (e) => {
                                            await obtenerSucursalesPorCompania(e.target.value)

                                        },
                                        required: true
                                    })}
                                    className="form-select form-select-sm" value={watch("compania")}>

                                    {
                                        listaCompanias?.length > 0 && listaCompanias.map(e => (
                                            <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                                        ))
                                    }

                                </select>
                            </div>
                            <div className="col-12 col-md-2">
                                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Sucursal</label>
                                <select
                                    {...register("sucursal", {
                                        onChange: async (e) => { await obtenerSedesPorSucursal(e.target.value) },
                                        required: true
                                    })}
                                    className="form-select form-select-sm"
                                    value={watch("sucursal")}

                                >
                                    {
                                        listaSucursales?.length > 0 && listaSucursales.map(e => (
                                            <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                                        ))
                                    }

                                </select>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Usuario</label>
                                <input

                                    {...register("nombre")}
                                    type="text"

                                    className="form-control form-control-sm"
                                    placeholder="Ingrese su usuario"
                                />

                            </div>
                            <div className="col-12 col-md-2">
                                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Fecha Inicial</label>
                                <input
                                    type="date"
                                    {...register("fechaInicial")}

                                    className="form-control form-control-sm"

                                />

                            </div>
                            <div className="col-12 col-md-2">
                                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Fecha Final</label>
                                <input
                                    type="date"
                                    {...register("fechaFinal")}

                                    className="form-control form-control-sm"

                                />

                            </div>
                            <div className="col-12 col-md-1">
                                <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">&nbsp;</label>
                                <div className={isMobile ? "text-center" : ""}>
                                    <button type="submit"  onClick={handleSubmit(onSubmitBuscar)}style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
                                        <BiSearch size={25} className="color-iconos" />
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                    <div className="tw-mt-2 tw-rounded-2xl tw-bg-white tw-p-3 tw-shadow-md tw-border tw-border-gray-100 tw-overflow-x-auto">
                        <table className="table table-hover tw-mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th scope="col" className="col text-center">id</th>
                                    <th scope="col" className="col text-center">Compañia</th>
                                    <th scope="col" className="col text-center">Sucursal</th>
                                    <th scope="col" className="col text-center">Usuario</th>
                                    <th scope="col" className="col text-center">Fecha y hora</th>
                                    <th scope="col" className="col text-center">Cod Programa</th>
                                    <th scope="col" className="col text-center">Descripcion</th>
                                    <th scope="col" className="col text-center">Observacion</th>


                                </tr>
                            </thead>
                            <tbody className={isLoading ? "" : "tabla-fade-in"}>
                                {
                                    isLoading ? (
                                        <TablaSkeleton rows={6} cols={6} />

                                    ) : (

                                        // falta api
                                        listaAuditoria?.length > 0 ? listaAuditoria.map((u) => (
                                            <tr key={u?.AudCod}>
                                                <td>{u?.AudCod}</td>
                                                <td>{obtenerLabel(listaCompanias, u?.AudCompPad)}</td>
                                                <td>{obtenerLabel(listaSucursales, u?.AudComp)}</td>
                                                <td>{u?.AudUse}</td>
                                                <td>{u?.AudFech}</td>
                                                <td>{u?.AudUrl}</td>
                                                <td>{u?.AudDesc1}</td>
                                                <td>{u?.observacion}</td>
                                                {/* <td>{obtenerLabel(listaSucursales, u?.UseComp)}</td>
                                                <td>{u?.TMSED10?.SedDesc}</td> */}
                                            </tr>
                                        )) :
                                            (
                                                (buscar) ? (
                                                    <tr>
                                                        <td colSpan={100} className="text-center">No hay registros</td>
                                                    </tr>
                                                ) : (
                                                    <tr>
                                                        <td colSpan={100} className="text-center">Realice una búsqueda</td>
                                                    </tr>
                                                )
                                            )
                                    )
                                }
                            </tbody>
                        </table>


                    </div>
                </div>
            </div>

        </>


    )
};
